import {GeoCoordinate} from "@renta-apps/athenaeum-toolkit";

export default class SignOutRequest {
    public location: GeoCoordinate | null = null;
}